export const creator_OMO8ZK1P = {
    custom_button_label: {
      recurring: 'View plans',
      recurring_single_plan: 'View plans',
    }
  };